import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Nav, Container, Row, Col, Modal, Button } from "react-bootstrap";
import { Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import moment from "moment";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import RowExpansion from "layouts/RowExpansion";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { mappingOptionNewItemPrCol, NumberFormat } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getPresentList } from "../../redux/handlers/logic/getPresentationList.handler";
import { getProductInfo } from "../../redux/handlers/logic/getProductInfo.handler";
import { getAllMstUnit } from "../../redux/handlers/master/getAllMstUnit.handler";
export function Product() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var businessID = null;
    var accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    businessID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.bus_business_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    var _useState = _sliced_to_array(useState(""), 2), filterTextPresent = _useState[0], setFilterTextPresent = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItems = _useState1[0], setFilteredItems = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), tabPage = _useState2[0], setTabPage = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), tabStatusProduct = _useState3[0], setTabStatusProduct = _useState3[1];
    var _useState4 = _sliced_to_array(useState(1), 2), tabStatusPresent = _useState4[0], setTabStatusPresent = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), openModelProduct = _useState5[0], setOpenModelProduct = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), headerName = _useState6[0], setheaderName = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), row = _useState7[0], setRow = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), rowData = _useState8[0], setRowData = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), filterText = _useState9[0], setFilterText = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), rowPresent = _useState10[0], setRowPresent = _useState10[1];
    var _useState11 = _sliced_to_array(useState(null), 2), presentTap = _useState11[0], setPresentTap = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), mstUnit = _useState12[0], setMstUnit = _useState12[1];
    useEffect(function() {
        if (tabPage == 2) {
            setheaderName("นำเสนอสินค้า");
            setTabStatusProduct(0);
        } else {
            setRow(row);
            setheaderName("สินค้าของฉัน");
        }
    }, [
        tabPage,
        filterText,
        tabStatusProduct,
        row
    ]);
    useEffect(function() {
        if (filterTextPresent) {
            setFilteredItems(rowPresent.filter(function(item) {
                return item.code && item.code.toLowerCase().includes(filterTextPresent.toLowerCase()) || item.name && item.name.toLowerCase().includes(filterTextPresent.toLowerCase());
            }));
        } else {
            setFilteredItems(rowPresent);
        }
    }, [
        rowPresent,
        filterTextPresent
    ]);
    var getPresentListReducer = useAppSelector(function(state) {
        return state.getPresentListReducer;
    });
    var getProductInfoReducer = useAppSelector(function(state) {
        return state.getProductInfoReducer;
    });
    var getAllMstUnitReducer = useAppSelector(function(state) {
        return state.getAllMstUnitReducer;
    });
    useEffect(function() {
        dispatch(getProductInfo(businessID));
        dispatch(getAllMstUnit());
    }, []);
    useEffect(function() {
        if (presentTap != null) {
            dispatch(getPresentList(businessID, {
                pd_ppresentation_status: presentTap
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            dispatch(getPresentList(businessID, {}, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        presentTap
    ]);
    useEffect(function() {
        setIsLoading(getPresentListReducer.isFetching);
        if (getPresentListReducer.data) {
            var data = getPresentListReducer.data.data;
            var newRow = data.map(function(item) {
                var _item_SysUser;
                return {
                    id: item.pd_ppresentation_id,
                    name: item.pd_ppresentation_name,
                    code: item.pd_ppresentation_code,
                    nunber: item.pd_ppresentation_totalproduct,
                    dateCreate: item.pd_ppresentation_credate,
                    dateRequest: item.pd_ppresentation_sendapprovedate,
                    inspector: item.pd_ppresentation_approveid,
                    inspectorName: (_item_SysUser = item.SysUser) === null || _item_SysUser === void 0 ? void 0 : _item_SysUser.sys_user_fullname,
                    remark: item.pd_ppresentation_remark,
                    status: item.pd_ppresentation_status,
                    statusName: item.pd_ppresentation_status === 1 ? "แบบร่าง" : item.pd_ppresentation_status === 2 ? "รอตรวจสอบ" : item.pd_ppresentation_status === 3 ? "ตรวจสอบแล้ว" : item.pd_ppresentation_status == 4 ? "ยกเลิก" : ""
                };
            });
            setRowPresent(newRow);
            setFilteredItems(newRow);
        }
    }, [
        getPresentListReducer
    ]);
    useEffect(function() {
        setIsLoading(getProductInfoReducer.isFetching);
        if (getProductInfoReducer.data) {
            if (tabStatusProduct == 0) {
                setRow(getProductInfoReducer.data.data);
                setRowData(getProductInfoReducer.data.data);
            } else {
                var filters = getProductInfoReducer.data.data.filter(function(val) {
                    return val.pd_product_status == tabStatusProduct;
                });
                setRowData(getProductInfoReducer.data.data);
                setRow(filters);
            }
        }
    }, [
        getProductInfoReducer,
        tabStatusProduct
    ]);
    useEffect(function() {
        if (filterText) {
            setRow(rowData.filter(function(item) {
                return item.pd_prduct_code && item.pd_prduct_code.toLowerCase().includes(filterText.toLowerCase()) || item.pd_product_nameth && item.pd_product_nameth.toLowerCase().includes(filterText.toLowerCase()) || item.pd_product_nameen && item.pd_product_nameen.toLowerCase().includes(filterText.toLowerCase());
            }));
        } else {
            setRow(rowData);
        }
    }, [
        rowData,
        filterText
    ]);
    useEffect(function() {
        setIsLoading(getAllMstUnitReducer.isFetching);
        if (getAllMstUnitReducer.data) {
            setMstUnit(getAllMstUnitReducer.data.data);
        }
    }, [
        getAllMstUnitReducer
    ]);
    var columns = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.pd_product_code;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/product/productnormal/edit/" + row.pd_product_id + "/view",
                        children: row.pd_product_code ? row.pd_product_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "ชื่อสินค้า",
            // center: "true",
            // width: "350px",
            selector: function(row) {
                return row.pd_product_nameth;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs(Stack, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fw-500",
                            children: row.pd_product_nameth
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "tc-12 fs-12",
                            children: row.pd_product_barcode
                        })
                    ]
                });
            }
        },
        {
            name: "ราคานำเสนอ",
            center: "true",
            width: "120px",
            selector: function(row) {
                return NumberFormat(row.pd_product_price, 2);
            }
        },
        {
            name: "ราคาขาย",
            center: "true",
            width: "120px",
            selector: function(row) {
                return NumberFormat(row.pd_product_recommentprice, 2);
            }
        },
        {
            name: "วันที่นำเสนอ",
            center: "true",
            width: "180px",
            selector: function(row) {
                return row.pd_product_approvesenddate ? moment(row.pd_product_approvesenddate).format("DD/MM/YYYY HH:mm") : "-";
            }
        },
        {
            name: "วันที่อนุมัติ",
            center: "true",
            width: "180px",
            selector: function(row) {
                return row.pd_product_approvedate ? moment(row.pd_product_approvedate).format("DD/MM/YYYY HH:mm") : "-";
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.status;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return row.pd_product_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6D788D)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "แบบร่าง"
                }) || row.pd_product_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รออนุมัติ"
                }) || row.pd_product_status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FFFFFF",
                        backgroundColor: "#10B02A",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติ"
                }) || row.pd_product_status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) || row.pd_product_status == 5 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6f42c1",
                        backgroundColor: "#e2d9f3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รอแก้ไข"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.pd_product_id;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: row.pd_product_status == 1 || row.pd_product_status == 5 ? /*#__PURE__*/ _jsx(Link, {
                        to: "/product/productnormal/edit/" + row.pd_product_id,
                        style: {
                            marginRight: 3
                        },
                        children: /*#__PURE__*/ _jsx(EditIcon, {
                            style: {
                                color: "#797A7A",
                                fontSize: 30,
                                borderRadius: 40,
                                background: "#E9E9E9",
                                padding: 5
                            }
                        })
                    }) : /*#__PURE__*/ _jsx(Link, {
                        to: "/product/productnormal/edit/" + row.pd_product_id + "/view",
                        style: {
                            marginRight: 3
                        },
                        children: /*#__PURE__*/ _jsx(VisibilityIcon, {
                            style: {
                                fontSize: 30,
                                borderRadius: 40,
                                background: "#FFF1DD",
                                color: "#FFA319",
                                padding: 5
                            }
                        })
                    })
                });
            }
        }
    ];
    var columnsDetail = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.pd_pdetail_code ? row.pd_pdetail_code : "-";
            },
            center: "true"
        },
        {
            name: "บาร์โค๊ด",
            selector: function(row) {
                return row.pd_pdetail_barcode ? row.pd_pdetail_barcode : "-";
            },
            center: "true"
        },
        {
            name: "คุณสมบัติสินค้า",
            selector: function(row) {
                return row.optionProduct ? row.optionProduct : "-";
            },
            center: "true"
        },
        {
            name: "หน่วยสินค้า",
            selector: function(row) {
                return row.pd_pdetail_unitid;
            },
            center: "true",
            // width: "170px",
            cell: function(row, index, column, id) {
                var find = mstUnit.find(function(val) {
                    return val.set_unit_id == row.pd_pdetail_unitid;
                });
                return /*#__PURE__*/ _jsx("div", {
                    className: "fs-14",
                    children: find ? find.set_unit_name : "-"
                });
            }
        },
        {
            name: "อัตตราส่วน",
            selector: function(row) {
                return row.pd_pdetail_continer ? row.pd_pdetail_continer : "-";
            },
            center: "true"
        },
        {
            name: "ราคานำเสนอ",
            selector: function(row) {
                return row.pd_pdetail_price ? row.pd_pdetail_price.toFixed(2) : "-";
            },
            center: "true"
        },
        {
            name: "ราคาแนะนำ",
            selector: function(row) {
                return row.pd_pdetail_recommentprice ? row.pd_pdetail_recommentprice.toFixed(2) : "-";
            },
            center: "true"
        },
        {
            name: "GP %",
            selector: function(row) {
                return row.pd_pdetail_gp;
            },
            center: "true",
            // width: "170px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "fs-13 tc-4",
                    children: row.pd_pdetail_gp ? row.pd_pdetail_gp.toFixed(2) : "-"
                });
            }
        }
    ];
    var columnsPresent = [
        {
            name: "รหัสลิสต์",
            selector: function(row) {
                return row.code;
            },
            center: "true",
            width: "130px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/product/present/" + row.id,
                        children: row.code ? row.code : "-"
                    })
                });
            }
        },
        {
            name: "วันที่สร้าง",
            selector: function(row) {
                return row.dateCreate;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return moment(row.dateCreate).format("DD/MM/YYYY");
            }
        },
        {
            name: "ชื่อลิสต์",
            selector: function(row) {
                return row.name;
            }
        },
        {
            name: "จำนวนรายการ",
            selector: function(row) {
                return row.nunber;
            },
            center: "true",
            width: "140px"
        },
        {
            name: "วันที่ขออนุมัติ",
            selector: function(row) {
                return row.dateRequest;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return row.dateRequest ? moment(row.dateRequest).format("DD/MM/YYYY") : "-";
            }
        },
        {
            name: "ผู้ตรวจสอบ",
            selector: function(row) {
                return row.inspector;
            },
            width: "180px",
            cell: function(row, index, column, id) {
                return row.inspector ? row.inspectorName : "-";
            }
        },
        {
            name: "หมายเหตุ",
            selector: function(row) {
                return row.remark ? row.remark : "-";
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.status;
            },
            center: "true",
            width: "140px",
            cell: function(row, index, column, id) {
                return row.status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6D788D)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "แบบร่าง"
                }) || row.status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รอตรวจสอบ"
                }) || row.status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FFFFFF",
                        backgroundColor: "#10B02A",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ตรวจสอบแล้ว"
                }) || row.status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ยกเลิก"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.id;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.status == 1 && /*#__PURE__*/ _jsx(Link, {
                            to: "/product/present/edit/" + row.id,
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/product/present/" + row.id,
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(VisibilityIcon, {
                                style: {
                                    color: "#FFA319",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#FFF1DD",
                                    padding: 5
                                }
                            })
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "สินค้าของฉัน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: tabPage == 2 && headerName
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: headerName
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Nav, {
                variant: "pills",
                defaultActiveKey: tabPage,
                onSelect: function(selectedKey) {
                    return setTabPage(selectedKey);
                },
                className: "mb-3",
                children: [
                    /*#__PURE__*/ _jsx(Nav.Item, {
                        children: /*#__PURE__*/ _jsx(Nav.Link, {
                            className: "tc-13 nav-danger",
                            eventKey: "1",
                            children: "สินค้าของฉัน"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Nav.Item, {
                        children: /*#__PURE__*/ _jsx(Nav.Link, {
                            className: "tc-13 nav-danger",
                            eventKey: "2",
                            children: "นำเสนอสินค้า"
                        })
                    })
                ]
            }),
            tabPage == 1 && /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        defaultActiveKey: tabStatusProduct,
                        onSelect: function(selectedKey) {
                            return setTabStatusProduct(selectedKey);
                        },
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "0",
                                    children: "ทั้งหมด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "1",
                                    children: "แบบร่าง"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "2",
                                    children: "รออนุมัติ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "3",
                                    children: "อนุมัติ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "4",
                                    children: "ไม่อนุมัติ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "5",
                                    children: "รอแก้ไข"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        children: [
                            /*#__PURE__*/ _jsx(CardBody, {
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 7
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 5,
                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "horizontal",
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: "ค้นหา...",
                                                        onKeyUp: function(e) {
                                                            return setFilterText(e.target.value);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        className: "btn btn-dg ml-2 width-30",
                                                        onClick: function() {
                                                            setOpenModelProduct(true);
                                                        //  setFormdata(formdefault);
                                                        },
                                                        children: "สร้างสินค้า"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(RowExpansion, {
                                data: row,
                                columns: columns,
                                columnsDetail: columnsDetail,
                                isSelectRows: true,
                                PerPage: 10
                            })
                        ]
                    })
                ]
            }),
            tabPage == 2 && /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        defaultActiveKey: tabStatusPresent,
                        onSelect: function(selectedKey) {
                            return setTabStatusPresent(selectedKey);
                        },
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "1",
                                    onClick: function() {
                                        setPresentTap(null);
                                    },
                                    children: "ทั้งหมด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "2",
                                    onClick: function() {
                                        setPresentTap(1);
                                    },
                                    children: "แบบร่าง"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "3",
                                    onClick: function() {
                                        setPresentTap(2);
                                    },
                                    children: "รอตรวจสอบ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "4",
                                    onClick: function() {
                                        setPresentTap(3);
                                    },
                                    children: "ตรวจสอบแล้ว"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        children: [
                            /*#__PURE__*/ _jsx(CardBody, {
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 7
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 5,
                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "horizontal",
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: "ค้นหารหัสลิสต์, ชื่อลิสต์",
                                                        onKeyUp: function(e) {
                                                            return setFilterTextPresent(e.target.value);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Link, {
                                                        className: "btn btn-dg ml-2 width-30",
                                                        to: "/product/present/create",
                                                        children: "นำเสนอสินค้า"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(DataTableLayout, {
                                item: filteredItems,
                                columns: columnsPresent,
                                isSelectRows: false,
                                PerPage: 10
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModelTypeProduct, {
                show: openModelProduct,
                onHide: function() {
                    return setOpenModelProduct(false);
                }
            })
        ]
    });
}
function ModelTypeProduct(props) {
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, props), {
        size: "md",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                className: "bg-text-danger",
                children: "เลือกรูปแบบสินค้า"
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Container, {
                    children: /*#__PURE__*/ _jsx(Stack, {
                        direction: "row",
                        justifyContent: "center",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            className: "border-radius-1 text-center",
                            to: "/product/productnormal/create",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "h5 mt-4 mb-2",
                                    children: "สินค้าทั่วไป"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "fs-12 tc-5",
                                    children: "(สามารถสร้างหลายอัตตราส่วนได้)"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "fs-12 tc-5",
                                    children: "เช่น ชิ้น, โหล, ลัง"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
}
